import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from "@angular/common/http";
import { EventService } from './controller/event.service';
import { EventComponent } from './view/event/event.component';
import { EventTitleComponent } from './view/event-title/event-title.component';
import { EventDescriptionComponent, SafeHtmlPipe } from './view/event-description/event-description.component';
import { EventHelpTextComponent } from './view/event-help-text/event-help-text.component';
import { RouterModule } from '@angular/router';
import { EventSuggestionsComponent } from './view/event-suggestions/event-suggestions.component';
import { EventRegisterComponent } from './view/event-register/event-register.component';
import { RegisterStepsComponent } from './view/register-steps/register-steps.component';
import { RegisterDatesComponent } from './view/register-dates/register-dates.component';
import { RegisterLieuComponent } from './view/register-lieu/register-lieu.component';
import { ProfilFormComponent } from './view/profil-form/profil-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from "../../helper/shared/shared.module";
import { NgSelectModule } from '@ng-select/ng-select';
import { RegisterConfirmComponent } from './view/register-confirm/register-confirm.component';
import { RegisterSlotsRemainingComponent } from './view/register-slots-remaining/register-slots-remaining.component';
import { PluralPipe } from '../../helper/core/quote.pipe';
import { EqualizerModule } from '../../helper/equalizer/equalizer.module';
import { RegisterTimezoneComponent } from './view/register-timezone/register-timezone.component';
import { SlotDisplayCommentaryComponent} from "./view/slot-display-commentary/slot-display-commentary.component";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    EqualizerModule
  ],
  providers: [
    EventService,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
  ],
  declarations: [
    EventComponent,
    EventTitleComponent,
    EventDescriptionComponent,
    EventHelpTextComponent,
    EventSuggestionsComponent,
    EventRegisterComponent,
    RegisterStepsComponent,
    RegisterDatesComponent,
    ProfilFormComponent,
    RegisterConfirmComponent,
    RegisterLieuComponent,
    RegisterTimezoneComponent,
    RegisterSlotsRemainingComponent,
    PluralPipe,
    SafeHtmlPipe,
    SlotDisplayCommentaryComponent
  ]
})
export class RegisterEventModule { }



// WEBPACK FOOTER //
// ./src/app/screens/register-event/register-event.module.ts